const CVUNavIcon = ({
  fill = 'rgb(15 208 139)'
}: {
  className?: string
  fill?: string
}) => (
  <svg
    width='24'
    height='28'
    viewBox='0 0 24 28'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5 4.65069C4.30921 4.65069 3.75 5.26835 3.75 6.03134V21.4947C3.75 22.2577 4.30921 22.8754 5 22.8754H19C19.6908 22.8754 20.25 22.2577 20.25 21.4947V6.03134C20.25 5.26835 19.6908 4.65069 19 4.65069H5ZM2.25 6.03134C2.25 4.35333 3.48079 2.9939 5 2.9939H19C20.5192 2.9939 21.75 4.35333 21.75 6.03134V21.4947C21.75 23.1727 20.5192 24.5322 19 24.5322H5C3.48079 24.5322 2.25 23.1727 2.25 21.4947V6.03134Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.0081 11.8413C11.4167 11.9164 11.6928 12.3432 11.6248 12.7945L10.4598 20.5262C10.3918 20.9775 10.0054 21.2824 9.59684 21.2073C9.18824 21.1322 8.91214 20.7055 8.98014 20.2542L10.1451 12.5225C10.2131 12.0712 10.5995 11.7662 11.0081 11.8413Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.5021 11.8413C14.9107 11.9164 15.1868 12.3432 15.1188 12.7945L13.9538 20.5262C13.8858 20.9775 13.4994 21.2824 13.0909 21.2073C12.6823 21.1322 12.4062 20.7055 12.4742 20.2542L13.6392 12.5225C13.7072 12.0712 14.0935 11.7662 14.5021 11.8413Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M8.05798 14.6278C8.05798 14.1703 8.39377 13.7994 8.80798 13.7994H15.899C16.3132 13.7994 16.649 14.1703 16.649 14.6278C16.649 15.0853 16.3132 15.4562 15.899 15.4562H8.80798C8.39377 15.4562 8.05798 15.0853 8.05798 14.6278Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.44995 18.4319C7.44995 17.9744 7.78574 17.6035 8.19995 17.6035H15.291C15.7052 17.6035 16.0409 17.9744 16.0409 18.4319C16.0409 18.8894 15.7052 19.2603 15.291 19.2603H8.19995C7.78574 19.2603 7.44995 18.8894 7.44995 18.4319Z'
      fill={fill}
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.25 9.34487C2.25 8.88736 2.58579 8.51648 3 8.51648H21C21.4142 8.51648 21.75 8.88736 21.75 9.34487C21.75 9.80238 21.4142 10.1733 21 10.1733H3C2.58579 10.1733 2.25 9.80238 2.25 9.34487Z'
      fill={fill}
    />
  </svg>
)

export default CVUNavIcon
